import { style } from 'styled-system';

const breakInside = style({
  prop: 'breakInside',
  cssProperty: 'breakInside'
});

export default breakInside;
